import React, { useEffect, useState } from 'react';
import config from './../../config';
import { isCrawler, isMobile } from '../../utils/commonUtils';
import { AD_PAGES } from '../../utils/adsUtils';
import PropTypes from 'prop-types';

const AdComponentRenderer = ({ uuid }) => {
  if (typeof window !== 'undefined') {
    const AdComponent = require('ad-react-wrapper').default;
    const { setConfig } = require('ad-react-wrapper');
    setConfig(config);
    return <AdComponent uuid={uuid} />;
  }
  return null;
};

AdComponentRenderer.propTypes = {
  uuid: PropTypes.string
};

export const AdWrapper = ({ adsPageName }) => {
  const [state, setState] = useState({
    isGoogleBot: false,
    adsContextId: null
  });
  useEffect(() => {
    const isGoogleBot = isCrawler();
    const adsContextId = Object.keys(AD_PAGES)?.find((element) => element === adsPageName);
    setState({
      isGoogleBot,
      adsContextId
    });
  }, []);

  const { isGoogleBot, adsContextId } = state;
  if (isGoogleBot || !adsContextId) {
    return null;
  }
  const { mobileContextId, desktopContextId } = AD_PAGES[adsContextId];
  const uuid = isMobile() ? mobileContextId : desktopContextId;
  return <AdComponentRenderer uuid={uuid} />;
};

AdWrapper.propTypes = {
  adsPageName: PropTypes.string
};
export default AdWrapper;
